const methods = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(",");
const fn = function () {};
const mockconsole = {};
let l = methods.length;

while (l--) {
    mockconsole[methods[l]] = fn;
}

export default mockconsole;
